import { render, staticRenderFns } from "./Form612.vue?vue&type=template&id=a228ae86&scoped=true&"
import script from "./Form612.vue?vue&type=script&lang=js&"
export * from "./Form612.vue?vue&type=script&lang=js&"
import style0 from "./Form612.vue?vue&type=style&index=0&id=a228ae86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a228ae86",
  null
  
)

export default component.exports